import AmplitudeHelper from "utils/analytics";

export const logEvent = ({
  eventname = "",
  amplitude = "",
  isUpdate = false,
  item = "",
}) => {
  switch (eventname) {
    case "button":
      AmplitudeHelper.logEvent(`${amplitude}_clicked`, {
        source: isUpdate
          ? "detailed_employee_page"
          : "single_employee_creation_page",
      });
      break;
    case "menuItem":
      AmplitudeHelper.logEvent(
        `${amplitude}${isUpdate ? "_changed" : "_filled"}`,
        {
          source: isUpdate
            ? "detailed_employee_page"
            : "single_employee_creation_page",
          input: item,
        }
      );
      break;
    default:
  }
};
